import { h, Host } from '@stencil/core';
import { isAnalyticsEnabled, send, clickExternalPartnerLinkEvent, viewExternalPartnerLink, EXTERNAL_PARTNER_NAME, pesIconSizes } from '@pes-ui/utils';
import { getData } from '../../globals/http';
import circular from './icon/circular_economy_logo.svg';
export class PesCircularEconomy {
  constructor() {
    this.renderTooltip = () => (h("pdp-icon-tooltip", { class: "sustainability__tooltip-trigger", icon: "information_stroke", iconSize: pesIconSizes.NANO, iconColor: "grey", position: "top" }, h("div", null, this.data.toolTipMessage, this.data.toolTipLearnMoreUrl && (h("a", { class: "link", href: this.data.toolTipLearnMoreUrl }, this.data.toolTipLearnMoreLabel)))));
    this.renderLink = (linkData) => {
      const { label, link } = linkData;
      if (link && isAnalyticsEnabled()) {
        send(viewExternalPartnerLink, {
          external_partner_name: EXTERNAL_PARTNER_NAME,
          external_partner_url: link,
        });
      }
      return (h("a", { class: "link", href: link, target: "_blank", onClick: () => this.onClick(link) }, label));
    };
    this.data = undefined;
    this.countryCode = undefined;
    this.productId = undefined;
    this.isStockLoad = undefined;
    this.stockRes = undefined;
    this.redirectLink = undefined;
  }
  componentWillLoad() {
    return this.getProductCount();
  }
  componentDidLoad() {
    if (this.redirectLink && isAnalyticsEnabled()) {
      send(viewExternalPartnerLink, {
        external_partner_name: EXTERNAL_PARTNER_NAME,
        external_partner_url: this.redirectLink,
      });
    }
  }
  onClick(link) {
    if (isAnalyticsEnabled()) {
      send(clickExternalPartnerLinkEvent, { external_partner_url: link });
    }
  }
  getProductCount() {
    const restUrl = `${this.data.apiEndPointUrl}/${this.countryCode}/${this.productId}`;
    return getData(false, restUrl, this.data.apiKey)
      .then((res) => {
      this.stockRes = res;
    })
      .catch(() => { });
  }
  renderMessageText(bulletPointText) {
    bulletPointText = bulletPointText.replace('{0}', this.stockRes['Circular-Stock-Quantity']);
    this.redirectLink = this.stockRes['Details-URL'];
    if (bulletPointText.indexOf('<a>') === -1 && bulletPointText.indexOf('&lt;a&gt;') === -1) {
      return bulletPointText;
    }
    const stringVal = bulletPointText;
    let regLt = /</g;
    let regGt = />/g;
    if (bulletPointText.indexOf('&lt;a&gt;') !== -1) {
      regLt = /&lt;/g;
      regGt = /&gt;/g;
    }
    const replacedVal = stringVal.replace(regLt, '#').replace(regGt, '#');
    const obj = replacedVal.split('#a#');
    const finalArr = [];
    obj.forEach((_item) => {
      if (_item) {
        if (_item.indexOf('#/a#') > -1) {
          const textVal = _item.split('#/a#');
          finalArr.push({ text: textVal[0], type: 'link' });
          if (textVal.length > 1 && textVal[1] !== '') {
            finalArr.push({ text: textVal[1], type: 'span' });
          }
        }
        else {
          finalArr.push({ text: _item, type: 'span' });
        }
      }
    });
    return (h("span", null, finalArr.map((itemLinks) => {
      if (itemLinks.type === 'link') {
        return this.renderLink({ label: itemLinks.text, link: this.redirectLink });
      }
      return itemLinks.text;
    })));
  }
  render() {
    return (h(Host, null, this.stockRes && this.stockRes['Circular-Stock-Quantity'] > 0 && (h("div", { class: "circular-economy" }, h("div", { class: "image-container" }, h("span", { innerHTML: circular })), h("div", { class: "content-container" }, h("span", { class: "content" }, this.renderMessageText(this.data.message)), this.renderTooltip())))));
  }
  static get is() { return "pes-circular-economy"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["circular-economy.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["circular-economy.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CircularEconomy",
          "resolved": "{ circularCertifiedLogo?: string; message?: string; apiEndPointUrl?: string; toolTipMessage?: string; toolTipLearnMoreLabel?: string; toolTipLearnMoreUrl?: string; apiKey?: string; enableCircularProducts?: boolean; enableCircularProductNewBadge?: boolean; }",
          "references": {
            "CircularEconomy": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "isStockLoad": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-stock-load",
        "reflect": false
      },
      "stockRes": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "CircularEconomyStock",
          "resolved": "{ Country: string; 'product-reference': string; 'product-exist': boolean; 'Circular-Stock-Quantity': number; 'Details-URL': string; }",
          "references": {
            "CircularEconomyStock": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "redirectLink": {}
    };
  }
}
